import './isvirtual';
import './maxsteps';
import './actualstep';
import './gobacktovirtual';
import './gobacktoreal';
import './resetsteps';
import './virtualconfig';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/index.js